<template>
  <div class="p-4">
    <div class="flex flex-col gap-4">
      <div class="flex items-center justify-between">
        <h3 class="text-lg font-medium text-gray-700">Kategoriler</h3>

        <!-- Değişiklikleri Kaydet butonu -->
        <VButton @click="$emit('save')" :button-text="hasChanges ? `Kaydet (${changedCategories.size})` : `Kaydet`" icon="file_download_done" :show-icon="true" class="shadow-sm" variant="success" size="sm" :is-loading="isSaving" :is-disabled="!hasChanges"/>
      </div>
    </div>
    <div class="relative mt-2">
      <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">
        <span class="material-symbols-outlined !text-[18px]">search</span>
      </span>
      <input type="text" v-model="searchQuery" placeholder="Kategori ara..." class="w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-colors shadow-sm"/>
      <button v-if="searchQuery" @click="searchQuery = ''" class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600">
        <span class="material-symbols-outlined !text-[18px]">close</span>
      </button>
    </div>
  </div>

  <div class="category-tree flex-1 overflow-auto p-4 pt-2 mt-2 thin-scrollbar">
    <template v-if="filteredCategories.length">
      <div v-for="category in filteredCategories" :key="category.id" class="category-item mb-2">
        <CategoryTreeItem :category="category" :selected-id="selectedCategoryId" :expanded-categories="expandedCategories" @select="$emit('select', $event)"/>
      </div>
    </template>
    <div v-else class="text-center py-6 text-gray-500 bg-white rounded-lg border border-gray-200 p-4">
      <span class="material-symbols-outlined !text-[36px] mb-2 text-gray-400">folder_off</span>
      <p class="text-sm">Gösterilecek kategori bulunamadı</p>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, defineProps, defineEmits } from 'vue'
import VButton from '@/components/base/buttons/VButton.vue'
import CategoryTreeItem from './CategoryTreeItem.vue'
import { filterCategories } from '../../utils/category/treeUtils'

const props = defineProps({
  categories: {
    type: Array,
    default: () => [],
  },
  selectedCategoryId: {
    type: [Number, String],
    default: null,
  },
  changedCategories: {
    type: Set,
    required: true,
  },
  isSaving: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['select', 'save'])

const searchQuery = ref('')
const expandedCategories = ref(new Set())

// Kategorilerde değişiklik var mı?
const hasChanges = computed(() => props.changedCategories.size > 0)

// Kategorileri filtrele
const filteredCategories = computed(() => {
  return filterCategories(props.categories, searchQuery.value, expandedCategories.value)
})

// Arama sorgusu değiştiğinde expandedCategories referansını güncelle
watch(searchQuery, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    expandedCategories.value = new Set(expandedCategories.value)
  }
})
</script>
